/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/ViewMode/ShowFutureEntries/Content"
  
}) {
let tabSelectedLedgerShowFutureEntriesValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.show_future_entries',
})
let onClick = fromHelpers.useOnToggle({
  children,
  viewPath
  
})
let tabSelectedLedgerViewModeValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.view_mode',
})
let constantData = 'transactions'
let aggregateData = fromAggregate.equals(tabSelectedLedgerViewModeValueData, constantData)
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 marginLeft="auto"
 data="tab.selected.ledger.show_future_entries"
 value={tabSelectedLedgerShowFutureEntriesValueData}
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text={aggregateData ? "Show future transactions" : "Show future invoices & claims"}
 data="tab.selected.ledger.view_mode"
 data="'transactions'"
 aggregate="/Data/aggregate.js equals"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}